import { QueryClientProvider } from '@tanstack/react-query';
import { AuthKitProvider } from '@workos-inc/authkit-react';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { ToastContainer } from '@/components/notifications/ToastContainer';
import { AuthProvider } from '@/providers/auth-provider';
import { ReactNode } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { env } from '@/lib/env';
import { queryClient } from '@/lib/query-client';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        // Log to error tracking service in production
        if (env.isProduction) {
          console.error('Application error:', { error, errorInfo });
          // TODO: Send to Sentry or similar service
        }
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AuthKitProvider clientId={env.workos.clientId} redirectUri={env.workos.redirectUri}>
          <AuthProvider>
            {children}
            <ToastContainer />
          </AuthProvider>
        </AuthKitProvider>
        {env.isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
